import { PayloadAction } from "@reduxjs/toolkit";

import { State } from "../types/state";

const setAutosCoordinates = (
  state: State,
  action: PayloadAction<State["historyUserLocation"]["data"]>
) => {
  state.historyUserLocation.data = action.payload;
};

export default setAutosCoordinates;
